(() => {
  const contextElement = document.getElementById('xc-market-context');
  if (!contextElement) return;

  let context = {};
  try {
    context = JSON.parse(contextElement.textContent || '{}');
  } catch (error) {
    return;
  }

  const hostname = String(window.location.hostname || '').toLowerCase();
  if ((hostname === 'tw.sihooxchair.com' || hostname === 'mo.sihooxchair.com') && !window.Shopify?.designMode) {
    const targetOrigin = context.hkOrigin || 'https://hk.sihooxchair.com';
    if (window.location.origin !== targetOrigin) {
      window.location.replace(
        `${targetOrigin}${window.location.pathname}${window.location.search}${window.location.hash}`
      );
      return;
    }
  }

  const hostMarket = hostname === 'tw.sihooxchair.com' ? 'tw' : hostname === 'mo.sihooxchair.com' ? 'mo' : '';
  const currentMarket = hostMarket || (context.market === 'tw' ? 'tw' : context.market === 'mo' ? 'mo' : 'hk');
  const currentCountry = hostMarket === 'tw' ? 'TW' : hostMarket === 'mo' ? 'MO' : String(context.country || window.Shopify?.country || '').toUpperCase();
  const fallbackTwdRate = Number(context.twdRate) > 0 ? Number(context.twdRate) : 4.06;

  const redirectToMarket = () => {
    if (window.Shopify?.designMode || currentCountry !== 'TW' && currentCountry !== 'HK' && currentCountry !== 'MO') return;

    const targetMarket = 'hk';
    if (targetMarket === currentMarket) return;

    const sessionKey = `xc-market-redirect:${currentCountry}`;
    try {
      if (window.sessionStorage.getItem(sessionKey) === '1') return;
      window.sessionStorage.setItem(sessionKey, '1');
    } catch (error) {
      // A blocked sessionStorage should never stop the storefront from rendering.
    }

    const origin = targetMarket === 'tw' ? context.twOrigin : targetMarket === 'mo' ? context.moOrigin : context.hkOrigin;
    if (!origin || window.location.origin === origin) return;
    window.location.replace(`${origin}${window.location.pathname}${window.location.search}${window.location.hash}`);
  };

  window.setTimeout(redirectToMarket, 0);

  if (currentMarket !== 'tw' && currentMarket !== 'mo') return;

  const replacementRules = currentMarket === 'mo' ? [
    [/SIHOO\s*西昊香港官方專賣店/g, 'SIHOO 西昊專賣店'],
    [/西昊香港官方專賣店/g, '西昊專賣店'],
    [/SIHOO\s*西昊香港專賣店/g, 'SIHOO 西昊專賣店'],
    [/西昊香港專賣店/g, '西昊專賣店'],
    [/SIHOO\s*西昊香港/g, 'SIHOO 西昊'],
    [/香港官方專賣店/g, '西昊專賣店'],
    [/香港專賣店/g, '西昊專賣店'],
    [/全香港免費順豐送貨上門/g, '澳門免費配送'],
    [/全港順豐免費送貨上門/g, '澳門免費配送'],
    [/全港順豐免費送貨/g, '澳門免費配送'],
    [/全港免費順豐送貨上門/g, '澳門免費配送'],
    [/全港免費順豐送貨/g, '澳門免費配送'],
    [/全港免費配送/g, '澳門免費配送'],
    [/全港免費送貨/g, '澳門免費配送'],
    [/全港免運/g, '澳門免費配送'],
    [/免費順豐送貨/g, '免費配送'],
    [/免費送貨/g, '免費配送'],
    [/順豐送貨上門/g, '配送'],
    [/順豐直送到家/g, '配送'],
    [/香港送貨如何安排？/g, '澳門配送如何安排？'],
    [/香港訂單/g, '澳門訂單'],
    [/香港站/g, '澳門站'],
    [/全港/g, '澳門'],
    [/香港/g, '澳門'],
    [/Hong Kong/g, 'Macau']
  ] : [
    [/SIHOO\s*西昊香港官方專賣店/g, 'SIHOO 西昊專賣店'],
    [/西昊香港官方專賣店/g, '西昊專賣店'],
    [/SIHOO\s*西昊香港/g, 'SIHOO 西昊'],
    [/香港官方專賣店/g, '官方專賣店'],
    [/全台灣免費海運配送/g, '海運配送，運費於結帳時顯示'],
    [/全台免費海運配送/g, '海運配送，運費於結帳時顯示'],
    [/台灣免費海運配送/g, '海運配送，運費於結帳時顯示'],
    [/免費海運配送/g, '海運配送，運費於結帳時顯示'],
    [/全香港免費順豐送貨上門/g, '海運配送，運費於結帳時顯示'],
    [/全港順豐免費送貨上門/g, '海運配送，運費於結帳時顯示'],
    [/全港順豐免費送貨/g, '海運配送，運費於結帳時顯示'],
    [/全港免費順豐送貨上門/g, '海運配送，運費於結帳時顯示'],
    [/全港免費順豐送貨/g, '海運配送，運費於結帳時顯示'],
    [/全港免費配送/g, '海運配送，運費於結帳時顯示'],
    [/全港免費送貨/g, '海運配送，運費於結帳時顯示'],
    [/全港免運/g, '海運配送，運費於結帳時顯示'],
    [/免費順豐送貨/g, '海運配送，運費於結帳時顯示'],
    [/免費送貨/g, '海運配送，運費於結帳時顯示'],
    [/Free SF Express delivery/gi, 'Sea freight, shipping shown at checkout'],
    [/Free Hong Kong delivery/gi, 'Sea freight, shipping shown at checkout'],
    [/Free delivery/gi, 'Sea freight, shipping shown at checkout'],
    [/順豐送貨上門/g, '海運配送，運費於結帳時顯示'],
    [/順豐直送到家/g, '海運配送，運費於結帳時顯示'],
    [/發貨按訂單安排/g, '海運配送，預計 10–15 天'],
    [/按訂單安排發貨/g, '海運配送，預計 10–15 天'],
    [/香港送貨如何安排？/g, '台灣配送如何安排？'],
    [/香港訂單/g, '台灣訂單'],
    [/香港站/g, '台灣站'],
    [/全港/g, '全台'],
    [/香港/g, '台灣'],
    [/Hong Kong/g, 'Taiwan']
  ];

  let lastRate = null;
  let processedValues = new WeakMap();

  const getCurrencyState = () => {
    const active = String(window.Shopify?.currency?.active || context.currency || '').toUpperCase();
    const nativeRate = Number(window.Shopify?.currency?.rate || 0);
    const hasNativeTwd = active === 'TWD' && Number.isFinite(nativeRate) && nativeRate > 0;
    return {
      active,
      rate: hasNativeTwd ? nativeRate : fallbackTwdRate,
      fallback: currentMarket === 'tw' && !hasNativeTwd,
      displayCurrency: currentMarket === 'tw' ? 'TWD' : active
    };
  };

  const convertLegacyPrices = (value, currencyState) => {
    if (currentMarket !== 'tw' || !Number.isFinite(currencyState.rate) || currencyState.rate <= 0) return value;
    const pricePattern = currencyState.fallback
      ? /(?:HK\$|HKD)\s*([\d,]+(?:\.\d+)?)|(?<![A-Z])\$\s*([\d,]+(?:\.\d+)?)/gi
      : /(?:HK\$|HKD)\s*([\d,]+(?:\.\d+)?)/gi;
    return value.replace(pricePattern, (match, rawWithCode, rawStandalone) => {
      const raw = rawWithCode || rawStandalone;
      const hkd = Number(String(raw).replace(/,/g, ''));
      if (!Number.isFinite(hkd)) return match;
      const twd = Math.round(hkd * currencyState.rate);
      return `NT$${new Intl.NumberFormat('zh-TW').format(twd)}`;
    });
  };

  const convertMislabelledTwdPrices = (value, currencyState) => {
    if (!currencyState.fallback) return value;
    return value.replace(/NT\$\s*([\d,]+(?:\.\d+)?)/g, (match, raw) => {
      const hkd = Number(String(raw).replace(/,/g, ''));
      if (!Number.isFinite(hkd)) return match;
      const twd = Math.round(hkd * currencyState.rate);
      return `NT$${new Intl.NumberFormat('zh-TW').format(twd)}`;
    });
  };

  const transform = (value) => {
    const currencyState = getCurrencyState();
    let result = convertLegacyPrices(value, currencyState);
    if (currencyState.fallback) result = result.replace(/\bHKD\s+\$/g, 'TWD NT$');
    replacementRules.forEach(([pattern, replacement]) => {
      result = result.replace(pattern, replacement);
    });
    return result;
  };

  const updateHead = () => {
    if (currentMarket !== 'tw' && currentMarket !== 'mo') return;

    if (document.title) document.title = transform(document.title);

    document.querySelectorAll('meta[name="description"], meta[property^="og:"], meta[name^="twitter:"]').forEach((element) => {
      if (!element.hasAttribute('content')) return;
      const value = element.getAttribute('content') || '';
      const nextValue = transform(value);
      if (nextValue !== value) element.setAttribute('content', nextValue);
    });

    const origin = currentMarket === 'tw' ? context.twOrigin : context.moOrigin;
    if (!origin) return;

    document.querySelectorAll('link[rel="canonical"]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);
        url.origin = origin;
        link.href = url.toString();
      } catch (error) {
        // A malformed canonical link should never stop market rendering.
      }
    });

    document.querySelectorAll('meta[property="og:url"], meta[name="twitter:url"]').forEach((element) => {
      try {
        const url = new URL(element.content, window.location.href);
        url.origin = origin;
        element.content = url.toString();
      } catch (error) {
        // A malformed social URL should never stop market rendering.
      }
    });
  };

  const isIgnored = (node) => {
    const parent = node.parentElement;
    return !parent || parent.closest('script, style, noscript, template, textarea, input, select, option, [data-xc-market-ignore]');
  };

  const processTextNode = (node) => {
    if (!(node instanceof Text) || isIgnored(node)) return;
    const currentValue = node.nodeValue || '';
    if (processedValues.get(node) === currentValue) return;
    const currencyState = getCurrencyState();
    const nextValue = currentValue.includes('NT$')
      ? convertMislabelledTwdPrices(currentValue, currencyState)
      : transform(currentValue);
    if (nextValue !== node.nodeValue) node.nodeValue = nextValue;
    processedValues.set(node, node.nodeValue || '');
  };

  const processRoot = (root) => {
    if (!root) return;
    if (root.nodeType === Node.TEXT_NODE) {
      processTextNode(root);
      return;
    }
    if (!(root instanceof Element || root instanceof Document || root instanceof DocumentFragment)) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) processTextNode(node);
  };

  const processAttributes = () => {
    document.querySelectorAll('[aria-label], [title]').forEach((element) => {
      ['aria-label', 'title'].forEach((attribute) => {
        if (!element.hasAttribute(attribute)) return;
        const value = element.getAttribute(attribute);
        const nextValue = transform(value || '');
        if (nextValue !== value) element.setAttribute(attribute, nextValue);
      });
    });
  };

  const findDisplayedTwdPrice = () => {
    const selectors = ['[data-xc-price]', '[data-xc-pdp-current]', '#price', '.price-row .price', '.product__info-container .price .price-item'];
    for (const selector of selectors) {
      const node = document.querySelector(selector);
      const match = node?.textContent?.match(/NT\$\s*([\d,]+(?:\.\d+)?)/);
      if (match) {
        const amount = Number(match[1].replace(/,/g, ''));
        if (Number.isFinite(amount) && amount > 0) return amount;
      }
    }
    return 0;
  };

  const updateWhatsAppPriceLines = (message) => {
    if (currentMarket !== 'tw') return message;
    const amount = findDisplayedTwdPrice();
    if (!amount) return message;
    const isH300 = /\/products\/h300-pro(?:[/?#]|$)/.test(window.location.pathname);
    const saving = isH300 ? Math.round(200 * fallbackTwdRate) : Math.round(amount * 0.05);
    const discounted = Math.max(0, amount - saving);
    const format = (value) => `NT$${new Intl.NumberFormat('zh-TW').format(Math.round(value))}`;
    const nextPrice = `・頁面售價：${format(amount)}`;
    const nextDiscount = message.includes('優惠後約') ? '・優惠後約：' : '・95 折後約：';
    const nextDiscountLine = `${nextDiscount}${format(discounted)}（預計節省 ${format(saving)}）`;
    return message
      .replace(/・頁面售價：[^\n]*/, nextPrice)
      .replace(/・(?:95 折後約|優惠後約)：[^\n]*/, nextDiscountLine);
  };

  const processWhatsAppLinks = () => {
  if (currentMarket !== 'tw' && currentMarket !== 'mo') return;
    document.querySelectorAll('a[href*="wa.me/"]').forEach((link) => {
      try {
        const url = new URL(link.href, window.location.href);
        const message = url.searchParams.get('text');
        if (!message) return;
        const nextMessage = updateWhatsAppPriceLines(transform(message));
        if (nextMessage !== message) {
          url.searchParams.set('text', nextMessage);
          link.href = url.toString();
        }
      } catch (error) {
        // A malformed third-party link should never stop market rendering.
      }
    });
  };

  // Rerun with a fresh pass when Shopify exposes the presentment rate.
  const runPagePass = () => {
    const { rate, displayCurrency, fallback } = getCurrencyState();
    document.documentElement.dataset.xcTwDisplayCurrency = displayCurrency;
    document.documentElement.dataset.xcTwCurrencyFallback = fallback ? 'true' : 'false';
    if (rate !== lastRate) {
      lastRate = rate;
      processedValues = new WeakMap();
    }
    processRoot(document.body);
    processAttributes();
    processWhatsAppLinks();
    updateHead();
  };

  runPagePass();
  window.setTimeout(runPagePass, 700);
  window.setTimeout(runPagePass, 1800);

  const observer = new MutationObserver((records) => {
    records.forEach((record) => {
      if (record.type === 'characterData') processTextNode(record.target);
      record.addedNodes.forEach((node) => processRoot(node));
    });
  });
  observer.observe(document.body, { attributes: true, attributeFilter: ['href', 'aria-label', 'title'], childList: true, characterData: true, subtree: true });

  window.dispatchEvent(new CustomEvent('xc:market-ready', {
    detail: { ...context, market: currentMarket, country: currentCountry, displayCurrency: getCurrencyState().displayCurrency, twdRate: fallbackTwdRate }
  }));
})();
